export default __webpack_public_path__ + "static/media/list_update_bans_page.49dc89cb.png";